import { ToastMessage } from "primereact/toast";
import { extractApiError, extractApiErrorUnknown } from "../api/errors";
import { serializeDate } from "./date";
import { ViewNames } from "../types";
import { SetterRegistry } from "../hooks/useSetDataByView/useSetDataByView.ts";

const dropdowns = [
  "driver",
  "trucks",
  "trailers",
  "deliveryStatus",
  "seller",
  "product",
  "buyer",
  "carrier",
  "salesContract",
  "purchaseContract",
];

const dateFields = ["unloadingDate", "loadingDate", "date"];

// Add truck and trailer to the type
export function createOnCellEditComplete<
  TRow extends {
    id: number;
    trucks?: string | null;
    trailers?: string | null;
  } & Record<string, unknown>,
  TView extends ViewNames,
>({
  setData,
  showToast,
}: {
  setData: SetterRegistry[TView]["setData"];
  showToast: (message: ToastMessage | ToastMessage[]) => void;
}) {
  return function onCellEditComplete<K extends keyof TRow>(e: {
    rowData: TRow;
    newValue: TRow[K];
    field: string;
    rowIndex: number;
  }) {
    const { rowData, newValue, field, rowIndex: _rowIndex } = e;
    // newValue is set to a label if dropdown value was not changed so we just return
    if (
      newValue &&
      dropdowns.includes(String(field)) &&
      isNaN(newValue as unknown as number)
    ) {
      return;
    }

    // if value hasn't changed, return
    if (String(rowData[field]) === String(newValue)) {
      return;
    }

    function parseNewValue(newValue: TRow[K]) {
      if (dateFields.includes(String(field))) {
        return serializeDate(new Date(newValue as string | number | Date));
      }
      // if (dateFields.includes(String(field)) && newValue === undefined) {
      //   return undefined;
      // }
      if (dropdowns.includes(String(field)) && newValue === undefined) {
        return null;
      }

      return newValue;
    }

    const newData = {
      id: rowData.id,
      [field]: parseNewValue(newValue),
    };

    // Reset truck and trailer if driver is changed
    if (field === "driver") {
      newData.trucks = null;
      newData.trailers = null;
    }
    const result = setData([newData]);
    if (result && result instanceof Promise) {
      result
        .then((result) => {
          if (result === null) {
            return;
          }
          result
            .filter((d) => d?.error !== undefined)
            .forEach(({ error }) => {
              showToast({
                severity: "error",
                summary: "Błąd",
                detail: extractApiError(error),
              });
            });
        })
        .catch((error) => {
          showToast({
            severity: "error",
            summary: "Błąd",
            detail: extractApiErrorUnknown(error),
          });
        });
    } else {
      console.error(
        `Expected setData to return a promise, got ${typeof result} instead}`,
      );
    }
  };
}
